import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class MainserviceService {
  sideTrans: boolean = false;
  hrsssidenav : boolean ;
  cbsidenav : boolean;
  notification : boolean;
  roleactive : boolean;
  selectedTab:any=0;
  selectedTab2:any=0;
   
  postDate: any;
  lcaNumber: any;
  lcaYear: any;
  state: any;
  city: any;
  lcaRole: any;

  postDateA: any;
  lcaNumberA: any;
  lcaYearA: any;
  stateA: any;
  cityA: any;
  lcaRoleA: any;

  createBackButton : boolean;

  
  baseUrl: string = "assets/api/data.json";

  baseUrl1: string= "assets/api/table.json";
  stateurl: string= "assets/api/state.json";
  cityurl: string= "assets/api/city.json";
  positionurl: string= "assets/api/lcarole.json";
  postdata: string= "assets/api/lcaepostdata.json";
  archivedata: string= "assets/api/lcaepostarcvdata.json";

  constructor(public http: HttpClient) { }
 

getpostdata(){
    return this.http.get(this.postdata);

  }
  getarchivedata(){
    return this.http.get(this.archivedata);

  }
 getstate(){
    return this.http.get(this.stateurl);

  }
  getcities(){
    return this.http.get(this.cityurl);
  }
  getposition(){
    return this.http.get(this.positionurl);

  }

  getTableData(){
    return this.http.get(this.baseUrl);

  }

  getTableData1(){
    return this.http.get(this.baseUrl1);

  }

  goback(){
    window.history.back();
  }
}
